(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pointerFine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Film grain overlay
    var grain = document.createElement('div');
    grain.className = 'wrought-grain';
    grain.setAttribute('aria-hidden', 'true');
    document.body.appendChild(grain);

    // Cursor-follow glow (desktop / fine-pointer devices only)
    if (pointerFine) {
      var glow = document.createElement('div');
      glow.className = 'wrought-glow';
      glow.setAttribute('aria-hidden', 'true');
      document.body.appendChild(glow);

      var raf = null;
      window.addEventListener(
        'pointermove',
        function (e) {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            glow.style.setProperty('--wrought-mx', e.clientX + 'px');
            glow.style.setProperty('--wrought-my', e.clientY + 'px');
            glow.classList.add('is-active');
            raf = null;
          });
        },
        { passive: true }
      );

      document.addEventListener('pointerleave', function () {
        glow.classList.remove('is-active');
      });
    }

    // Button click spark micro-interaction
    if (!reduceMotion) {
      var sparkLayer = document.createElement('div');
      sparkLayer.className = 'wrought-spark-layer';
      sparkLayer.setAttribute('aria-hidden', 'true');
      document.body.appendChild(sparkLayer);

      var sparkSelector = 'button, .button, [type="submit"], a.button';

      document.addEventListener('click', function (e) {
        var target = e.target && e.target.closest ? e.target.closest(sparkSelector) : null;
        if (!target) return;

        var rect = target.getBoundingClientRect();
        var cx = typeof e.clientX === 'number' && e.clientX !== 0 ? e.clientX : rect.left + rect.width / 2;
        var cy = typeof e.clientY === 'number' && e.clientY !== 0 ? e.clientY : rect.top + rect.height / 2;
        var count = 6;

        for (var i = 0; i < count; i++) {
          var spark = document.createElement('span');
          spark.className = 'wrought-spark';
          var angle = (Math.PI * 2 * i) / count + Math.random() * 0.6;
          var distance = 18 + Math.random() * 22;
          spark.style.left = cx + 'px';
          spark.style.top = cy + 'px';
          spark.style.setProperty('--wrought-sx', Math.cos(angle) * distance + 'px');
          spark.style.setProperty('--wrought-sy', Math.sin(angle) * distance + 'px');
          sparkLayer.appendChild(spark);
          (function (el) {
            setTimeout(function () {
              el.remove();
            }, 520);
          })(spark);
        }
      });
    }
  });
})();
